import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { Icon } from '@/assets/icons/LibrarySvg';
import { tileButton } from '@/components/Board/commonToolbarStyles';
import { NumberInput } from '@/components/Board/NumberInput';
import Tooltip from '@/components/Common/Tooltip';
const STROKE_CONSTANTS = {
    DEFAULT_COLOR: '#000000',
    DEFAULT_WIDTH: 2,
    MIN_WIDTH: 1,
    MAX_WIDTH: 20,
};
/**
 * Компонент для управления обводкой элемента
 */
export const StrokeSettings = ({ element, onStrokeChange, onStrokeWidthChange, onStrokeEnabledChange, }) => {
    var _a, _b, _c;
    const [localColor, setLocalColor] = useState(STROKE_CONSTANTS.DEFAULT_COLOR);
    const [localWidth, setLocalWidth] = useState(STROKE_CONSTANTS.DEFAULT_WIDTH);
    const [strokeEnabled, setStrokeEnabled] = useState(false);
    // Синхронизация с текущим элементом
    useEffect(() => {
        var _a, _b, _c;
        const strokeValue = (_a = element.props) === null || _a === void 0 ? void 0 : _a.stroke;
        const strokeWidthValue = (_b = element.props) === null || _b === void 0 ? void 0 : _b.strokeWidth;
        const strokeEnabledValue = (_c = element.props) === null || _c === void 0 ? void 0 : _c.strokeEnabled;
        if (typeof strokeValue === 'string' && strokeValue) {
            setLocalColor(strokeValue);
        }
        else {
            setLocalColor(STROKE_CONSTANTS.DEFAULT_COLOR);
        }
        const width = typeof strokeWidthValue === 'number' && !isNaN(strokeWidthValue)
            ? strokeWidthValue
            : STROKE_CONSTANTS.DEFAULT_WIDTH;
        setLocalWidth(width);
        const enabled = typeof strokeEnabledValue === 'boolean' ? strokeEnabledValue : strokeValue !== undefined;
        setStrokeEnabled(enabled);
    }, [(_a = element.props) === null || _a === void 0 ? void 0 : _a.stroke, (_b = element.props) === null || _b === void 0 ? void 0 : _b.strokeWidth, (_c = element.props) === null || _c === void 0 ? void 0 : _c.strokeEnabled]);
    const handleColorChange = useCallback((color) => {
        setLocalColor(color);
        onStrokeChange(color);
        // Если обводка была выключена, включаем её при изменении цвета
        if (!strokeEnabled) {
            setStrokeEnabled(true);
            onStrokeEnabledChange(true);
        }
    }, [onStrokeChange, strokeEnabled, onStrokeEnabledChange]);
    const handleWidthChange = useCallback((value) => {
        const clampedValue = Math.max(STROKE_CONSTANTS.MIN_WIDTH, Math.min(STROKE_CONSTANTS.MAX_WIDTH, value));
        setLocalWidth(clampedValue);
        onStrokeWidthChange(clampedValue);
        // Если обводка была выключена, включаем её при изменении ширины
        if (!strokeEnabled) {
            setStrokeEnabled(true);
            onStrokeEnabledChange(true);
        }
    }, [onStrokeWidthChange, strokeEnabled, onStrokeEnabledChange]);
    const handleEnabledChange = useCallback((enabled) => {
        setStrokeEnabled(enabled);
        onStrokeEnabledChange(enabled);
    }, [onStrokeEnabledChange]);
    return (_jsxs("div", { style: {
            background: strokeEnabled ? '#1D2225' : '#2A2D2ECD',
            borderRadius: 10,
            padding: 0,
            paddingRight: 10,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
        }, children: [_jsx(Tooltip, { text: "\u041E\u0431\u0432\u043E\u0434\u043A\u0430", position: "top", children: _jsx("button", { type: "button", onClick: () => handleEnabledChange(!strokeEnabled), style: tileButton(strokeEnabled, { boxShadow: 'none' }), "aria-label": "\u041E\u0431\u0432\u043E\u0434\u043A\u0430", children: _jsx(Icon, { name: "border_1" }) }) }), _jsxs("div", { style: {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4,
                    opacity: strokeEnabled ? 1 : 0.2,
                }, children: [_jsx(NumberInput, { value: localWidth, min: STROKE_CONSTANTS.MIN_WIDTH, max: STROKE_CONSTANTS.MAX_WIDTH, step: 1, onChange: handleWidthChange, disabled: !strokeEnabled, width: 50 }), _jsx(Tooltip, { text: "\u0426\u0432\u0435\u0442 \u043E\u0431\u0432\u043E\u0434\u043A\u0438", position: "top", children: _jsx("input", { type: "color", value: localColor, onChange: (e) => handleColorChange(e.target.value), disabled: !strokeEnabled, style: {
                                width: 32,
                                height: 32,
                                border: '1px solid rgba(255, 255, 255, 0.08)',
                                background: 'transparent',
                                cursor: strokeEnabled ? 'pointer' : 'not-allowed',
                            } }) })] })] }));
};
